const initialState = {
  selectedAsset: null,
  tagInfo: null,
};

export default function assetReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_SELECTED_ASSET":
      return { ...state, selectedAsset: action.payload };
    case "SET_TAG_INFO":
      return { ...state, tagInfo: action.payload };
    default:
      return state;
  }
}